'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function post(_x4, _x5, _x6, _x7) {
  return _post.apply(this, arguments);
}

function _post() {
  _post = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(service, token, path, data) {
    var headers,
        url,
        response,
        text,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            headers = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : {};
            _context2.prev = 1;
            // construct API service URL
            url = service + path;
            headers.Authorization = "Bearer ".concat(token);
            headers['Content-Type'] = 'application/json';
            _context2.next = 7;
            return fetch(url, {
              method: 'POST',
              headers: headers,
              body: data
            });

          case 7:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 14;
              break;
            }

            _context2.next = 11;
            return response.text();

          case 11:
            text = _context2.sent;
            console.error("GET ".concat(url, ": ").concat(text));
            return _context2.abrupt("return", {
              response: null,
              error: text
            });

          case 14:
            return _context2.abrupt("return", {
              response: response,
              error: null
            });

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](1);
            console.error(_context2.t0);
            return _context2.abrupt("return", {
              response: null,
              error: _context2.t0
            });

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 17]]);
  }));
  return _post.apply(this, arguments);
}

var AsertoClient = /*#__PURE__*/function () {
  function AsertoClient(options) {
    _classCallCheck(this, AsertoClient);

    _defineProperty(this, "token", void 0);

    _defineProperty(this, "endpoint", void 0);

    _defineProperty(this, "service", void 0);

    _defineProperty(this, "policyRoot", void 0);

    _defineProperty(this, "__displayStateMap", void 0);

    if (!options || !options.accessToken) {
      throw new Error('AsertoClient: must provide access token');
    }

    this.token = options.accessToken;
    this.endpoint = options.displayStateMapEndpoint || '/__displaystatemap';
    this.service = options.serviceUrl || new URL(window.location.origin);
    this.policyRoot = options.policyRoot || '';
    this.__displayStateMap = {};
  }

  _createClass(AsertoClient, [{
    key: "reload",
    value: function () {
      var _reload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(body) {
        var headers,
            result,
            error,
            map,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headers = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return post(this.service, this.token, this.endpoint, body, headers);

              case 3:
                result = _context.sent;

                if (!(result.error !== null)) {
                  _context.next = 9;
                  break;
                }

                error = result.error;
                throw new Error("AsertoClient: ".concat(error instanceof Error ? error.message : error));

              case 9:
                _context.next = 11;
                return result.response.json();

              case 11:
                map = _context.sent;
                this.__displayStateMap = map;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reload(_x) {
        return _reload.apply(this, arguments);
      }

      return reload;
    }()
  }, {
    key: "displayStateMap",
    value: function displayStateMap() {
      return this.__displayStateMap;
    }
  }, {
    key: "getDisplayState",
    value: function getDisplayState(method, path, policyRoot) {
      var root = policyRoot || this.policyRoot;
      var key;

      if (path) {
        // path was passed in - use METHOD/path convention
        if (root) {
          // root was passed in - use root/METHOD/path
          key = "".concat(root, "/").concat(method).concat(path);
        } else {
          key = "".concat(method).concat(path);
        }
      } else {
        // treat the first argument as the key
        key = method;
      }

      var map = this.__displayStateMap[key];

      if (!map) {
        throw new Error("AsertoClient: access map does not contain the key ".concat(key));
      }

      return map;
    }
  }]);

  return AsertoClient;
}();

function createAsertoClient(_x, _x2) {
  return _createAsertoClient.apply(this, arguments);
}

function _createAsertoClient() {
  _createAsertoClient = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options, body) {
    var aserto;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            aserto = new AsertoClient(options);
            _context.next = 3;
            return aserto.reload(body);

          case 3:
            return _context.abrupt("return", aserto);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createAsertoClient.apply(this, arguments);
}

exports.AsertoClient = AsertoClient;
exports["default"] = createAsertoClient;
